import { User } from './User';

export class InvitationStatus {
	public id: string;
	public message: string;
	public isClaimed: boolean;
}
